/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectsControllerRemoveMutationResponse, ProjectsControllerRemovePathParams, ProjectsControllerRemoveQueryParams, ProjectsControllerRemove401, ProjectsControllerRemove403, ProjectsControllerRemove404 } from "../../models/projectsController/ProjectsControllerRemove";

function getProjectsControllerRemoveUrl(id: ProjectsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/projects/${id}` as const }  
  return res
}

/**
 * @summary Delete a project
 * {@link /api/v1/projects/:id}
 */
export async function projectsControllerRemove(id: ProjectsControllerRemovePathParams["id"], params?: ProjectsControllerRemoveQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectsControllerRemoveMutationResponse, ResponseErrorConfig<ProjectsControllerRemove401 | ProjectsControllerRemove403 | ProjectsControllerRemove404>, unknown>({ method : "DELETE", url : getProjectsControllerRemoveUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}